if (!customElements.get('akr-back-to-top')) {
  customElements.define(
    'akr-back-to-top',
    class AkrBackToTop extends HTMLElement {
      connectedCallback() {
        this.querySelector('button')?.addEventListener('click', () => {
          const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          window.scrollTo({ top: 0, behavior: reduceMotion ? 'auto' : 'smooth' });
          // Keyboard users continue from the top of the page, not from where the button was.
          document.getElementById('MainContent')?.focus({ preventScroll: true });
        });

        // Show the button once the visitor has scrolled more than half a screen; one check per frame.
        this.onScroll = () => {
          if (this.pending) return;
          this.pending = true;
          requestAnimationFrame(() => {
            this.pending = false;
            this.classList.toggle('is-visible', window.scrollY > window.innerHeight * 0.5);
          });
        };
        window.addEventListener('scroll', this.onScroll, { passive: true });
        this.onScroll();
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this.onScroll);
      }
    }
  );
}
